// ==============================|| LOGO SVG ||============================== //

const Logo = () => <img src={process.env.REACT_APP_LOGO_URL || 'https://via.placeholder.com/150'} alt="Middleware" width="65" />;

export default Logo;
